import React, { useState, createContext } from 'react'

export const GlobalContext = createContext()

const Provider = props => {
    
    const [isDark, setIsDark] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)

    return (
        <GlobalContext.Provider
            value={{
                isDark,
                menuOpen,
                toggleTheme: () => setIsDark(!isDark),
                toggleMenu: () => setMenuOpen(!menuOpen)
            }}
        >{props.children}</GlobalContext.Provider>
    )

}

export default ({ element }) => <Provider>{element}</Provider>